import classNames from 'classnames'
import { KeyCodes } from '../../constants/appConstants'
import ModalBackground from './ModalBackground'
import ModalContainer from './ModalContainer'
import ModalHeader from './ModalHeader'
import PropTypes from 'prop-types'
import React, { cloneElement, Children, Component } from 'react'

class Modal extends Component {
  componentDidMount() {
    if (this.props.dismissable) {
      document.addEventListener('keyup', this.handleEsc)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleEsc)
  }

  handleEsc = e => {
    if (e.which === KeyCodes.ESC) {
      this.props.onClose()
    }
  }

  render() {
    const { children, className, dismissable, open, onClose } = this.props

    return (
      <div
        className={classNames('fv-modal', className)}
        style={{ display: open ? 'block' : 'none' }}
      >
        <ModalBackground open={open} onClick={() => dismissable && onClose()} />
        <ModalContainer>
          {Children.map(children, child =>
            child.type === ModalHeader
              ? cloneElement(child, { dismissable, onClose })
              : child
          )}
        </ModalContainer>
      </div>
    )
  }
}

Modal.propTypes = {
  children: PropTypes.node,
  dismissable: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
}

Modal.defaultProps = {
  dismissable: true,
  open: false
}

export default Modal
export { default as ModalHeader } from './ModalHeader'
export { default as ModalFooter } from './ModalFooter'
export { default as ModalBody } from './ModalBody'



// WEBPACK FOOTER //
// ../src/components/fv-ui/Modal.js